import { connect } from 'react-redux';
import ExecutionEnvironment from 'exenv';

import { HYDRA_PERSONALIZATION_MARKER } from 'constants/hydraTests';
import { makePersonalizationMarker } from 'helpers/PersonalizationUtils';
import { checkIsHomepage } from 'history/historyFactory';
import { getAssignmentGroup, triggerAssignment } from 'actions/ab';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardCategory from 'components/common/melodyCard/MelodyCardCategory';
import PersonalizationMarker from 'components/landing/PersonalizationMarker';

import css from 'styles/components/landing/melodyCategory.scss';

const stylesWithNoBackground = ['bottomAlignedWithNoBackground'];
const stylesWithBottomAligned = ['bottomAlignedWithNoBackground'];

export const MelodyCategory = ({ slotName, slotDetails, onLandingComponentClick, shouldLazyLoad, location, isCustomer, hydraPersonalizationMarker }) => {
  const isHomepage = checkIsHomepage(location.pathname);
  const isTestPage = location.pathname === '/c/testcontentpage';
  const { heading, style, categories, monetateId } = slotDetails;
  const noBackground = stylesWithNoBackground.includes(style);
  const bottomAligned = stylesWithBottomAligned.includes(style);

  if (categories?.length) {
    if (style === 'featureNav') {
      const altCss = {
        featureCss: css.featureCss,
        imgCss: css.imgCss
      };

      return (
        <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
          <div className={css.items}>
            {categories.slice(0, 4).map((category, i) => {
              const { gae } = category;
              return <MelodyCardCategory
                cardData={category}
                onLandingComponentClick={onLandingComponentClick}
                key={`${gae}-${i}`}
                eventLabel="melodyCategoryFeatureNav"
                melodyCardTestId="melodyCategoryFeatureNav"
                shouldLazyLoad={shouldLazyLoad}
                altCss={altCss} />;
            })}
          </div>
        </div>);
    }
    return (
      <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
        {heading && (
          <h2 className={css.heading}>
            {heading}
            {/* Only show PersonalizationMarker on homepage, and if customer is not recognized.  Recognized PMark is dealth with
                inside MelodyPersonalizedCategories, as if a customer is recognized but they don't have relevent opal info, there is potential
                to still see sitemerch curated categories
            */}
            {(isHomepage || isTestPage) && !isCustomer && makePersonalizationMarker({
              PersonalizationMarker,
              isCustomerRecognized: isCustomer,
              isPersonalized: true,
              componentName: 'MelodyPersonalizedBrand',
              sourcePage: 'LANDING_PAGE',
              location
            }, hydraPersonalizationMarker)}
          </h2>
        )}
        <MelodyCarousel>
          {categories.map((category, i) => {
            const { gae } = category;
            return <MelodyCardCategory
              cardData={category}
              onLandingComponentClick={onLandingComponentClick}
              key={`${gae}-${i}`}
              eventLabel="melodyCategory"
              melodyCardTestId="melodyCategory"
              shouldLazyLoad={shouldLazyLoad}
              bottomAligned={bottomAligned}
              noBackground={noBackground}/>;
          })}
        </MelodyCarousel>
      </div>
    );
  } else {
    return false;
  }
};

function mapStateToProps(state) {
  const location = ExecutionEnvironment.canUseDOM ? window.location : state.routing.locationBeforeTransitions || {};
  return {
    firstName: state.holmes?.firstName,
    isCustomer: !!state.cookies['x-main'],
    hydraPersonalizationMarker: getAssignmentGroup(HYDRA_PERSONALIZATION_MARKER, state),
    triggerAssignment,
    location
  };
}

export default connect(mapStateToProps, {
})(MelodyCategory);
